<template>
  <div
    class="w-full pb-0 laptop:pb-10 pt-10"
    :class="gradientBg ? gradientBg : isWhiteBg ? 'bg-white' : isDarkBlue ? 'bg-blue-700' : 'bg-blue-300'"
  >
    <div
      class="gridClass flex justify-between"
      :class="
        isReverse
          ? 'flex-col laptop:flex-row'
          : 'flex-col-reverse laptop:flex-row'
      "
    >
      <div class="pb-0 flex flex-col laptop:pe-10">
        <div class="mt-6">
          <div v-if="details.title">
            <h1
              class="font-bold text-xl laptop:text-2xl mb-1 laptop:mb-5 text-center laptop:text-start"
              :class="isDarkBlue ? 'text-white' : ''"
              v-text="details.title"
            />
            <div
              class="font-semibold laptop:font-bold text-justify text-base leading-7"
              :class="isDarkBlue ? 'text-white' : ''"
              v-html="details.desc"
            />
          </div>
          <div v-else>
            <slot name="rightSection"></slot>
          </div>
        </div>
        <div
          v-if="details.option1 || details.option2"
          class="block laptop:flex flex-row flex-start items-start my-10"
        >
          <div v-if="details.option1" class="me-4">
            <div
              class="flex justify-start items-start"
              v-for="i in details.option1"
              :key="i.id"
            >
              <div class="w-5 ml-0">
                <div class="mt-1">
                  <IconTik class="fill-blue-700 scale-75 laptop:scale-100" />
                </div>
              </div>
              <p class="font-bold">{{ i.txt }}</p>
            </div>
          </div>
          <div v-if="details.option2">
            <div
              class="flex justify-start items-center"
              v-for="i in details.option2"
              :key="i.id"
            >
              <div class="w-5 ml-0">
                <div class="-mt-1">
                  <IconTik class="fill-blue-700 scale-75 laptop:scale-100" />
                </div>
              </div>
              <p class="font-bold">{{ i.txt }}</p>
            </div>
          </div>
        </div>
        <slot name="button"></slot>
        <div
          v-if="details.firstButton || details.secondButton"
          class="flex mt-10 flex-col laptop:flex-row [&>*]:mb-4 [&>*]:laptop:mb-0"
          :class="[details?.firstButton.isFull ? '[&>*]:laptop:w-full' : '[&>*]:laptop:w-[45%]', details.secondButton ? 'justify-between' : 'justify-center']"
        >
          <!-- firstButton -->
          <template v-if="details.firstButton">
            <template v-if="details.firstButton.url">
              <NuxtLink :to="details.firstButton.url">
                <BaseButton
                  size="full"
                  :text="details.firstButton.text"
                  styleType="primary"
                  :classes="details.firstButton.classes"
                />
              </NuxtLink>
            </template>
            <template v-else-if="details.firstButton.scrollTo">
              <BaseButton
                size="full"
                :text="details.firstButton.text"
                styleType="primary"
                @click="scrollTo(details.firstButton.scrollTo)"
              />
            </template>
            <template v-else-if="details.firstButton.modalId == 'main'">
              <BaseButton
                size="full"
                :text="details.firstButton.text"
                styleType="primary"
                @click="showMainModal"
              />
            </template>
            <template v-else>
              <BaseButton
                size="full"
                :text="details.firstButton.text"
                styleType="primary"
              />
            </template>
          </template>
          <!-- secondButton -->
          <template v-if="details.secondButton">
            <template v-if="details.secondButton.url">
              <NuxtLink :to="details.secondButton.url">
                <BaseButton
                  is-shadow
                  size="full"
                  :text="details.secondButton.text"
                  :styleType="details.secondButton.isShadow ? 'shadow' : 'secondary'"
                />
              </NuxtLink>
            </template>
            <template v-else-if="details.secondButton.modalId == 'main'">
              <BaseButton
                is-shadow
                size="full"
                :text="details.secondButton.text"
                :styleType="details.secondButton.isShadow ? 'shadow' : 'secondary'"
                @click="showMainModal"
              />
            </template>
            <template v-else>
              <BaseButton
                is-shadow
                size="full"
                :text="details.secondButton.text"
                :styleType="details.secondButton.isShadow ? 'shadow' : 'secondary'"
              />
            </template>
          </template>
        </div>
      </div>
      <div class="min-w-[50%] mt-6">
        <NuxtImg
          v-if="details.img"
          sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
          width="1000"
          height="1000"
          quality="100"
          format="webp"
          class="w-full rounded-xl"
          :class="details.imgClass"
          :src="details.img"
          :alt="details.title"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  details: Object,
  isWhiteBg: Boolean,
  isDarkBlue: Boolean,
  isReverse: Boolean,
  gradientBg: String
});

const scrollTo = (id) => {
  const position = findPosition(document.getElementById(id));
  window.scroll(0, position[0] - 100);
};

const findPosition = (obj) => {
  var currenttop = 0;
  if (obj.offsetParent) {
    do {
      currenttop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [currenttop];
  }
};

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};
</script>
